import classNames from "classnames";
import get from "lodash/get";
import {ReactNode} from "react";
import {IconType} from "react-icons";

import {FormLabel} from "@/components/form/FormLabel.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {SelectOption} from "@/components/select/Select.types.ts";

interface RadioGroupProps {
  name: string;
  options: SelectOption[];
  labelIcons?: Record<string, IconType>;
  labelDescriptions?: Record<string, string | ReactNode>;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
  hasRequiredLabel?: boolean;
}

const RadioGroupIcon = ({icon}: {icon?: IconType}) => {
  if (!icon) {
    return null;
  }

  return <Icon icon={icon} display={"inline"} removeDivDimensions className="ms-2" />;
};

export const RadioGroup = ({
  name,
  value,
  options,
  labelIcons,
  labelDescriptions,
  required,
  hasRequiredLabel = true,
  onChange,
}: RadioGroupProps) => (
  <>
    {options.map((o, idx) => (
      <div key={`radio-${o.value}`} className="form-check mb-0">
        <input
          className="form-check-input"
          id={`id-${o.value}`}
          value={o.value}
          type="radio"
          name={name}
          required={required}
          defaultChecked={o.value === value}
          onChange={() => onChange(o.value)}
        />
        <FormLabel forId={`id-${o.value}`} className="form-check-label">
          <span className={classNames("d-inline-block", {"mb-3": idx < options.length - 1})}>
            <span className="pulseTextBodyBold">{o.label}</span>
            <RadioGroupIcon icon={get(labelIcons, o.value)} />
            {labelDescriptions && labelDescriptions[o.value] && (
              <div className="pulseTextBody mt-1">{labelDescriptions[o.value]}</div>
            )}
          </span>
          {required && hasRequiredLabel && <span className="ms-2 text-danger">*</span>}
        </FormLabel>
      </div>
    ))}
  </>
);
